import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { PatientApi } from '@core/apis/patient/patient.api';
import { PatientDTO } from '@core/apis/patient/patient.dto';
import { IPatientGets } from '@core/apis/patient/patient.interface';
import { OrderByEnum } from '@oranta-mis/sdk';
import { TranslocoHelper } from '@core/helpers/transloco.helper';
import { IPaginationGet } from '@core/interfaces/interface';
import { ClinicStore } from '@core/stores/clinic.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ColumnPersonEnum, ITableChangesConfig, ITableRow, Table, TableColumn } from '@oranta-mis/ui-library';
import { patientListColumnHeader } from './identify-patient-list';

interface IRenderTable extends ITableRow<PatientDTO> {
  created_at: string | null;
}

@Component({
  selector: 'app-identify-patient-list',
  imports: [TranslocoModule, CommonModule, Table],
  templateUrl: './identify-patient-list.component.html',
  styleUrls: ['./identify-patient-list.component.scss'],
})
@UntilDestroy()
export class IdentifyPatientListComponent {
  @Output() public patientSelected = new EventEmitter<PatientDTO>();

  public columnHeaderPatient!: TableColumn[];
  public patientsPaginated!: IPaginationGet<PatientDTO[]>;
  public patients: IRenderTable[] = [];
  public isLoading: boolean = false;

  private config!: ITableChangesConfig;

  constructor(
    private readonly patientApi: PatientApi,
    private readonly clinicStore: ClinicStore,
    private readonly i18n: TranslocoHelper,
  ) {}

  ngOnInit(): void {
    this.columnHeaderPatient = patientListColumnHeader(this.i18n);
  }

  public setConfig(config: ITableChangesConfig): void {
    this.config = config;
    this.getPatients(this.config);
  }

  private renderObject(arr: PatientDTO[]): IRenderTable[] {
    const datePipe = new DatePipe('en-US');
    return arr.map((v) => {
      return {
        id: v.id,
        item: v,
        person: {
          type: ColumnPersonEnum.patient,
          data: v,
        },
        created_at: datePipe.transform(v.createdAt, 'dd/MM/YYYY, HH:mm'),
      };
    });
  }

  private getPatients(config?: ITableChangesConfig) {
    this.isLoading = true;
    let settings: IPatientGets = {
      pagination: {
        page: config?.page || 1,
        perPage: config?.perPage || 10,
      },
      clinicId: this.clinicStore.get()?.id,
      // коли перейдем на всіх апі на CamelCase, то це можна буде видалити
      orderBy: { createdAt: config?.orderBy?.['created_at'] || config?.orderBy?.['createdAt'] || OrderByEnum.desc },
    };

    // if (this.staffStore.get()?.id) settings = Object.assign({ staff_id: this.staffStore.get()?.id }, settings);
    // if (this.clinicStore.get()?.id) settings = Object.assign({ clinic_id: this.clinicStore.get()?.id }, settings);
    // if (config?.orderBy) settings = Object.assign({ order_by: config.orderBy }, settings);
    if (config?.search) settings.search = config.search || '';

    this.patientApi
      .gets(settings)
      .pipe(untilDestroyed(this))
      .subscribe((patients) => {
        this.isLoading = false;
        this.patients = this.renderObject(patients.list);
        this.patientsPaginated = patients;
      });
  }

  public patientSelect(item: IRenderTable): void {
    const patient = item.item;
    if (!patient) return;
    this.patientSelected.emit(patient);
  }
}
